var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6393 21.833L9.97266 15.1663L11.8393 13.233L15.306 16.6997V5.83301H17.9727V16.6997L21.4393 13.233L23.306 15.1663L16.6393 21.833ZM8.63932 27.1663C7.90599 27.1663 7.27843 26.9055 6.75666 26.3837C6.23488 25.8619 5.97355 25.2339 5.97266 24.4997V20.4997H8.63932V24.4997H24.6393V20.4997H27.306V24.4997C27.306 25.233 27.0451 25.861 26.5233 26.3837C26.0015 26.9063 25.3735 27.1672 24.6393 27.1663H8.63932Z",
    fill: "url(#paint0_linear_722_63)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_63",
    x1: 16.6393,
    y1: 5.83301,
    x2: 16.6393,
    y2: 27.1663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.c1764030e63c837dad279d6d7bb594a1.svg";
export { ForwardRef as ReactComponent };